import { ID } from './id';
import { LocalizedString } from './localized-string';
import { DefaultMetricOptions } from './metric-template';
import { Timestamp } from './timestamp';

export type GoalMetric = {
  id: DefaultMetricOptions | ID;
  startValue: number | null;
  targetValue: number | null;
  unit: MetricUnit | null;
  entries: MetricEntry[] | null;
};

export type MetricEntry = {
  id: ID;
  value: number;
  date: Timestamp;
  mode: MetricEntryMode;
};

export type MetricUnit = {
  name: LocalizedString | string;
  id: ID | null;
  format: LocalizedString | null;
  symbol: LocalizedString | null;
};

export enum MetricEntryMode {
  Absolute = 'absolute',
  Relative = 'relative',
}
